import React, { Fragment, useContext } from 'react';
import { store } from './Fleets';
import Button from '@material-ui/core/Button';
import useRules from "../../../../../hooks/useRules";


const AddButtons = () => {
  const { dispatch } = useContext(store);
  const [rules,hasRule,isAdmin] = useRules();
  const handleAddFleet = () => {
    dispatch({ type: 'SHOW_ADD_FLEET_DIALOG', payload: true });
  };
  const handleAddFleetOption = () => {
    dispatch({ type: 'SHOW_ADD_FLEET_OPTIONS_DIALOG', payload: true });
  };
  return (
    <Fragment>
      {isAdmin && <Button
        variant="contained"
        size="large"
        color="secondary"
        onClick={handleAddFleet}
      >
        افزودن ناوگان
      </Button>}
      {isAdmin && <Button
        variant="contained"
        size="large"
        color="secondary"
        onClick={handleAddFleetOption}
      >
        افزودن ویژگی
      </Button>}
    </Fragment>
  );
};

export default AddButtons;
